module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226649214_04_ch1#ch1"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("1")]), _vm._v("Introduction to the History and Geography of Neotropical Mammals")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Bruce D. Patterson and Leonora P. Costa")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226649214_05_pt1#pt1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1. THE GEOLOGICAL SETTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226649214_06_ch2#ch2"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("2")]), _vm._v("Punctuated Isolation: The Making and Mixing of South America’s Mammals")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Darin A. Croft")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226649214_07_ch3#ch3"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("3")]), _vm._v("Origins, Radiations, and Distribution of South American Mammals: From Greenhouse to Icehouse Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Francisco J. Goin, Javier N. Gelfo, Laura Chornogubsky, Michael O. Woodburne, and Thomas Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_08_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("4")]), _vm._v("Cenozoic Andean Faunas: Shedding New Light on South American Mammal Evolution, Biogeography, Environments, and Tectonics")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("John J. Flynn, Reynaldo Charrier, Darin A.Croft, and Andre R. Wyss")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_09_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("5")]), _vm._v("On the Evolution of Large Size in Mammalian Herbivores of Cenozoic Faunas of Southern South America")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Sergio F. Vizcaíno, Guillermo H. Cassini, Néstor Toledo, and M. Susana Bargo")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_10_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("6")]), _vm._v("Evolution of the South American Carnivores (Mammalia, Carnivora): A Paleontological Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Francisco J. Prevosti and Leopoldo H. Soibelzon")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_11_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("7")]), _vm._v("A Molecular View on the Evolutionary History and Biogeography of Neotropical Carnivores (Mammalia, Carnivora)")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Eduardo Eizirik")])]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226649214_12_pt2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2. REGIONAL PATTERNS")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_13_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("8")]), _vm._v("Hierarchical Organization of Neotropical Mammal Diversity and Its Historical Basis")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Sergio Solari, Paúl M. Velazco, and Bruce D. Patterson")])]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_14_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad"
  }, [_vm._v("9")]), _vm._v("West Indian Mammals: The Old, the New, and the Recently Extinct")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_c('em', [_vm._v("Liliana M. Dávalos and Samuel T. Turvey")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_15_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("10")]), _vm._v("Biogeography of Central American Mammals: Patterns and Processes")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Ana Laura Almendra and Duke S. Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_16_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("11")]), _vm._v("Biogeography of Mammals from the Guianas of South America")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Burton K. Lim")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_17_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("12")]), _vm._v("Speciation in Amazonia: Patterns and Predictions of a Network of Hypotheses")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Cibele R. Bonvicino and Marcelo Weksler")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_18_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("13")]), _vm._v("Historical Fragmentation Shaping Vertebrate Diversification in the Atlantic Forest Biodiversity Hotspot")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Leonora P. Costa and Yuri L. R. Leite")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_19_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("14")]), _vm._v("Mammals of the Cerrado and Caatinga: Distribution Patterns of the Tropical Open Biomes of Central South America")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Ana Paula Carmignotto, Mario de Vivo, and Alfredo Langguth")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_20_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("15")]), _vm._v("The Role of the Andes in the Diversification and Biogeography of Neotropical Mammals")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Bruce D. Patterson, Sergio Solari, and Paúl M. Velazco")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_21_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad-1"
  }, [_vm._v("16")]), _vm._v("Mammalian Biogeography of Patagonia and Tierra del Fuego")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author-1"
  }, [_c('em', [_vm._v("Enrique P. Lessa, Guillermo D´Elía, and Ulyses F. J. Pardiñas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-backt"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_22_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_23_toxind#tax",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TAXONOMIC INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226649214_24_subind#sub",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SUBJECT INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b93acae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226649214_03_toc.vue
// module id = 63
// module chunks = 0